import React, { Component } from 'react';
import PropTypes from 'prop-types';
import mixpanel from 'mixpanel-browser';
import { connect } from 'react-redux';
import ProductImageCard from '../ProductImageCard';
import { ProductCellColumn, ProductImageCardWrapper } from './styled';
import VerticalSpacer from '../VerticalSpacer/VerticalSpacer';
import ProductListProductInfo from '../ProductInfoCard/ProductListProductInfo';
import productInfoDataSanitizer from '../ProductInfoCard/productInfoDataSanitizer';
import { getProductTrackingData, normalizeProductSelected } from '../../helpers';
import TrackingEvents from '../../common/models/TrackingEvents';
import withCountryCode from '../../components/RoutesHoc/RoutesHoc';

const mapStateToProps = ({ api: { filterSettings, sortFilterSelect } }) => ({
  filterSettings,
  sortFilterSelect
});

class ProductCell extends Component {
  componentDidMount() {
    const { filterSettings, sortFilterSelect, currencySymbol, product } = this.props;
    const trackingData = getProductTrackingData(product, currencySymbol, {
      filterSettings,
      sortType: sortFilterSelect
    });

    mixpanel.track_links(
      `#pr-${product.product_id}`,
      TrackingEvents.productSelected(),
      normalizeProductSelected(trackingData.product, trackingData.categoryDepartment)
    );
  }

  render() {
    const {
      filterSettings,
      sortFilterSelect,
      currencySymbol,
      product,
      s3BasePath,
      isDesktop,
      showSale = false,
      width,
      height,
      bright,
      lazyLoad,
      placeholderWidth,
      placeholderHeight,
      buildUrlWithCountry
    } = this.props;

    const DESKTOP_PRODUCT_IMAGE_WIDTH = '170px';
    const DESKTOP_PRODUCT_IMAGE_HEIGHT = '227px';

    return (
      <ProductCellColumn data-cy="product-cell" isDesktop={isDesktop}>
        <div data-cy-price={product.rrp} data-cy-pid={product.product_id}>
          <a id={`pr-${product.product_id}`} href={buildUrlWithCountry(product.url)} style={{ textDecoration: 'none' }}>
            <ProductImageCardWrapper>
              <ProductImageCard
                images={product.images}
                padTop="0"
                s3BasePath={s3BasePath}
                width={isDesktop ? DESKTOP_PRODUCT_IMAGE_WIDTH : width}
                height={isDesktop ? DESKTOP_PRODUCT_IMAGE_HEIGHT : height}
                product={product}
                lazyLoad={lazyLoad}
                placeholderWidth={placeholderWidth || (isDesktop ? DESKTOP_PRODUCT_IMAGE_WIDTH : width)}
                placeholderHeight={placeholderHeight || (isDesktop ? DESKTOP_PRODUCT_IMAGE_HEIGHT : height)}
              />
              <VerticalSpacer height="14px" />
            </ProductImageCardWrapper>
            <ProductListProductInfo
              bright={bright}
              currencySymbol={currencySymbol}
              product={productInfoDataSanitizer(product)}
              showSale={showSale}
              width="100%"
            />
          </a>
        </div>
      </ProductCellColumn>
    );
  }
}

ProductCell.propTypes = {
  currencySymbol: PropTypes.string.isRequired,
  isDesktop: PropTypes.bool,
  product: PropTypes.object.isRequired,
  s3BasePath: PropTypes.string.isRequired,
  showSale: PropTypes.bool,
  lazyLoad: PropTypes.bool,
  placeholderHeight: PropTypes.string,
  placeholderWidth: PropTypes.string,
  buildUrlWithCountry: PropTypes.func.isRequired
};

export default withCountryCode(connect(mapStateToProps)(ProductCell));
